type CreatedThreadRoute =
  | {
      to: "/thread/$threadId";
      params: { threadId: string };
    }
  | {
      to: "/$slug/thread/$threadId";
      params: { slug: string; threadId: string };
    };

/**
 * スレ立て後の遷移先。mixSlug指定時(総合カタログ)はmixマウント内の
 * 板slug付きスレページへrouter遷移し、フルリロードを避ける。
 */
export function getCreatedThreadRoute(
  threadId: string,
  mixSlug?: string,
): CreatedThreadRoute {
  if (mixSlug !== undefined) {
    return {
      to: "/$slug/thread/$threadId",
      params: { slug: mixSlug, threadId },
    };
  }
  return {
    to: "/thread/$threadId",
    params: { threadId },
  };
}
